/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { LocalDate } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { PaymentsServiceSwitchQuotePaymentResult } from "./PaymentsServiceSwitchQuotePaymentResult";
import {
  PaymentsServiceSwitchQuotePaymentResultFromJSON,
  PaymentsServiceSwitchQuotePaymentResultFromJSONTyped,
  PaymentsServiceSwitchQuotePaymentResultToJSON,
  PaymentsServiceSwitchQuotePaymentResultToJSONTyped,
} from "./PaymentsServiceSwitchQuotePaymentResult";

/**
 *
 * @export
 * @interface SelectQuoteResult
 */
export interface SelectQuoteResult {
  /**
   *
   * @type {boolean}
   * @memberof SelectQuoteResult
   */
  didMarkShipmentOnHold: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SelectQuoteResult
   */
  didSendCancelPickupEmail: boolean;
  /**
   *
   * @type {LocalDate}
   * @memberof SelectQuoteResult
   */
  updatedPickupDate?: LocalDate | null;
  /**
   *
   * @type {boolean}
   * @memberof SelectQuoteResult
   */
  didSelectNewQuote: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SelectQuoteResult
   */
  didClearProNumber: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SelectQuoteResult
   */
  didBookNewPickup: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SelectQuoteResult
   */
  didRegenerateDocuments: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SelectQuoteResult
   */
  didHandleCustomsDocuments: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SelectQuoteResult
   */
  didUpdateXeroProvisionalCarrierInvoice: boolean;
  /**
   *
   * @type {boolean}
   * @memberof SelectQuoteResult
   */
  didUpdateLineItems: boolean;
  /**
   *
   * @type {PaymentsServiceSwitchQuotePaymentResult}
   * @memberof SelectQuoteResult
   */
  paymentsResult?: PaymentsServiceSwitchQuotePaymentResult | null;
  /**
   *
   * @type {string}
   * @memberof SelectQuoteResult
   */
  paymentsError?: string | null;
  /**
   *
   * @type {string}
   * @memberof SelectQuoteResult
   */
  insuranceReferralReason?: string | null;
  /**
   *
   * @type {boolean}
   * @memberof SelectQuoteResult
   */
  success: boolean;
}

/**
 * Check if a given object implements the SelectQuoteResult interface.
 */
export function instanceOfSelectQuoteResult(
  value: object,
): value is SelectQuoteResult {
  if (
    !("didMarkShipmentOnHold" in value) ||
    value["didMarkShipmentOnHold"] === undefined
  )
    return false;
  if (
    !("didSendCancelPickupEmail" in value) ||
    value["didSendCancelPickupEmail"] === undefined
  )
    return false;
  if (
    !("didSelectNewQuote" in value) ||
    value["didSelectNewQuote"] === undefined
  )
    return false;
  if (
    !("didClearProNumber" in value) ||
    value["didClearProNumber"] === undefined
  )
    return false;
  if (!("didBookNewPickup" in value) || value["didBookNewPickup"] === undefined)
    return false;
  if (
    !("didRegenerateDocuments" in value) ||
    value["didRegenerateDocuments"] === undefined
  )
    return false;
  if (
    !("didHandleCustomsDocuments" in value) ||
    value["didHandleCustomsDocuments"] === undefined
  )
    return false;
  if (
    !("didUpdateXeroProvisionalCarrierInvoice" in value) ||
    value["didUpdateXeroProvisionalCarrierInvoice"] === undefined
  )
    return false;
  if (
    !("didUpdateLineItems" in value) ||
    value["didUpdateLineItems"] === undefined
  )
    return false;
  if (!("success" in value) || value["success"] === undefined) return false;
  return true;
}

export function SelectQuoteResultFromJSON(json: any): SelectQuoteResult {
  return SelectQuoteResultFromJSONTyped(json, false);
}

export function SelectQuoteResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SelectQuoteResult {
  if (json == null) {
    return json;
  }
  return {
    didMarkShipmentOnHold: json["didMarkShipmentOnHold"],
    didSendCancelPickupEmail: json["didSendCancelPickupEmail"],
    updatedPickupDate:
      json["updatedPickupDate"] == null ? undefined : json["updatedPickupDate"],
    didSelectNewQuote: json["didSelectNewQuote"],
    didClearProNumber: json["didClearProNumber"],
    didBookNewPickup: json["didBookNewPickup"],
    didRegenerateDocuments: json["didRegenerateDocuments"],
    didHandleCustomsDocuments: json["didHandleCustomsDocuments"],
    didUpdateXeroProvisionalCarrierInvoice:
      json["didUpdateXeroProvisionalCarrierInvoice"],
    didUpdateLineItems: json["didUpdateLineItems"],
    paymentsResult:
      json["paymentsResult"] == null
        ? undefined
        : PaymentsServiceSwitchQuotePaymentResultFromJSON(
            json["paymentsResult"],
          ),
    paymentsError:
      json["paymentsError"] == null ? undefined : json["paymentsError"],
    insuranceReferralReason:
      json["insuranceReferralReason"] == null
        ? undefined
        : json["insuranceReferralReason"],
    success: json["success"],
  };
}

export function SelectQuoteResultToJSON(json: any): SelectQuoteResult {
  return SelectQuoteResultToJSONTyped(json, false);
}

export function SelectQuoteResultToJSONTyped(
  value?: SelectQuoteResult | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    didMarkShipmentOnHold: value["didMarkShipmentOnHold"],
    didSendCancelPickupEmail: value["didSendCancelPickupEmail"],
    updatedPickupDate: value["updatedPickupDate"],
    didSelectNewQuote: value["didSelectNewQuote"],
    didClearProNumber: value["didClearProNumber"],
    didBookNewPickup: value["didBookNewPickup"],
    didRegenerateDocuments: value["didRegenerateDocuments"],
    didHandleCustomsDocuments: value["didHandleCustomsDocuments"],
    didUpdateXeroProvisionalCarrierInvoice:
      value["didUpdateXeroProvisionalCarrierInvoice"],
    didUpdateLineItems: value["didUpdateLineItems"],
    paymentsResult: PaymentsServiceSwitchQuotePaymentResultToJSON(
      value["paymentsResult"],
    ),
    paymentsError: value["paymentsError"],
    insuranceReferralReason: value["insuranceReferralReason"],
    success: value["success"],
  };
}
